import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getDatabase } from 'firebase/database';

// Support both VITE_ and REACT_APP_ prefixes during migration
// Check import.meta.env first (Vite way), then fallback to REACT_APP_ if available
const FIREBASE_CONFIG = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || import.meta.env.REACT_APP_FIREBASE_API_KEY || '',
  appId: import.meta.env.VITE_FIREBASE_ID || import.meta.env.REACT_APP_FIREBASE_ID || '',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || import.meta.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '',
  messagingSenderId:
    import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || import.meta.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || import.meta.env.REACT_APP_FIREBASE_PROJECT_ID || '',
  storageBucket:
    import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || import.meta.env.REACT_APP_FIREBASE_STORAGE_BUCKET || '',
};

// Debug: Log environment status (remove after verification)
if (!FIREBASE_CONFIG.apiKey) {
  console.error('Firebase API key not found. Check environment variables.');
  console.log('Available env vars:', Object.keys(import.meta.env));
  console.log('import.meta.env:', import.meta.env);

  // Check if this is a Vercel deployment
  if (typeof window !== 'undefined' && window.location.hostname.includes('vercel.app')) {
    console.error('⚠️ VERCEL DEPLOYMENT ISSUE: Environment variables are not being injected.');
    console.error('Please add VITE_* variables in Vercel Dashboard → Settings → Environment Variables');
  }
}

export const firebaseApp = initializeApp(FIREBASE_CONFIG);
export const auth = getAuth(firebaseApp);
export const storage = getStorage(firebaseApp);
export const database = getDatabase(firebaseApp);
